import React from 'react';
import { Alert, Divider, Input, Modal, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export const loadCompanyDeletePermission = async () => {
  try {
    const res = await fetch('/api/companies/delete-permission', {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    });
    if (!res.ok) return false;
    const data = await res.json();
    return data?.canDelete === true;
  } catch {
    return false;
  }
};

const getDeleteImpactScopes = (t) => [
  t('companyEdit.deleteImpactUsers') || '公司使用者、角色、權限設定',
  t('companyEdit.deleteImpactWorkflows') || '工作流程定義、執行記錄、步驟記錄',
  t('companyEdit.deleteImpactForms') || '電子表單、表單實例、審批、報表及文件輸出',
  t('companyEdit.deleteImpactDatasets') || 'DataSet、資料列、匯入排程及處理記錄',
  t('companyEdit.deleteImpactContacts') || '聯絡人、廣播群組、標籤、日曆事件及相關資源',
  t('companyEdit.deleteImpactWhatsapp') || 'WhatsApp 模板、訊息、Webhook / Flow 相關設定',
  t('companyEdit.deleteImpactCommerce') || 'Commerce 客戶、商品、目錄、訂單、價格卡及 WPA 權限資料',
  t('companyEdit.deleteImpactAiBilling') || 'AI 員工、API Provider 設定、用量計費、Wix 開通記錄',
  t('companyEdit.deleteImpactKnowledge') || '知識庫分類、文件及版本'
];

export const confirmDeleteCompany = ({
  companyId,
  companyName,
  canDeleteCompany,
  t,
  onDeleted
}) => {
  if (!companyId) return;
  if (!canDeleteCompany) {
    message.error(t('companyEdit.deleteTenantAdminOnly') || '只有 Tenant_Admin 可以刪除公司');
    return;
  }

  const expectedText = String(companyName || companyId).trim();
  let confirmText = '';

  Modal.confirm({
    title: t('companyEdit.deleteConfirmTitle') || '刪除公司前請小心確認',
    icon: <ExclamationCircleOutlined />,
    width: 720,
    okText: t('companyEdit.deleteConfirmOk') || '我已備份並確認刪除',
    cancelText: t('companyEdit.deleteConfirmCancel') || '取消',
    okType: 'danger',
    content: (
      <div>
        <Alert
          type="error"
          showIcon
          message={t('companyEdit.deleteBackupWarningTitle') || '此操作可能永久刪除或影響此公司的相關資料'}
          description={t('companyEdit.deleteBackupWarningDesc') || '刪除前請先完成資料庫及檔案備份，並確認不再需要此公司的流程、表單、商務及 WhatsApp 記錄。部分資料表可能因外鍵限制而阻止刪除，系統會回報錯誤。'}
          style={{ marginBottom: 16 }}
        />
        <div style={{ marginBottom: 8, fontWeight: 600 }}>
          {t('companyEdit.deleteImpactTitle') || '可能受影響的資料範圍：'}
        </div>
        <ul style={{ paddingLeft: 20, marginTop: 0 }}>
          {getDeleteImpactScopes(t).map(scope => (
            <li key={scope}>{scope}</li>
          ))}
        </ul>
        <Divider style={{ margin: '16px 0' }} />
        <div style={{ marginBottom: 8 }}>
          {(t('companyEdit.deleteTypeCompanyName') || '請輸入公司名稱「{name}」以確認刪除。').replace('{name}', expectedText)}
        </div>
        <Input
          placeholder={expectedText}
          onChange={(e) => { confirmText = e.target.value; }}
        />
      </div>
    ),
    onOk: async () => {
      if (confirmText.trim() !== expectedText) {
        message.error(t('companyEdit.deleteConfirmTextMismatch') || '確認文字不正確，已取消刪除');
        return Promise.reject(new Error('confirm text mismatch'));
      }

      const token = localStorage.getItem('token');
      const res = await fetch(`/api/companies/${companyId}`, {
        method: 'DELETE',
        headers: { Authorization: 'Bearer ' + token }
      });
      if (!res.ok) {
        let detail = '';
        try {
          const err = await res.json();
          detail = err.detail || err.error || res.statusText;
        } catch {
          detail = res.statusText;
        }
        message.error(detail ? `${t('companyEdit.deleteFailed') || '刪除失敗'}：${detail}` : (t('companyEdit.deleteFailed') || '刪除失敗'));
        return Promise.reject(new Error(detail || 'delete failed'));
      }

      message.success(t('companyEdit.deleteSuccess') || '已刪除');
      if (typeof onDeleted === 'function') onDeleted();
    }
  });
};
